const MB_2_FILE_LIMIT = 2145728

export const uploadImage = (
  event,
  setUploadImages = () => {},
  handleFileSizeError = () => {},
  fileLimit = MB_2_FILE_LIMIT
) => {
  const fileList = event.target.files
  const file = fileList ? fileList[0] : null

  if (!file) throw new Error('uploadImage :: no file')

  if (file.size > fileLimit) {
    handleFileSizeError()
    return
  }

  if (fileList && file) {
    const file = event.target.files[0]
    const imagePreview = URL.createObjectURL(file)
    
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      setUploadImages(file, imagePreview)
    }
  }
}
